import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ListIconArrowDown from "../../../styles/images/png/ListIconArrowDown.png";
import ListIconArrowUp from "../../../styles/images/png/ListIconArrowUp.png";
import Link from "@mui/material/Link";
import { Link as ReactRouterLink } from "react-router-dom";
import {
     DashboardIcon,
     LocationIcon,
     ParticipantsIcon,
     HomeContentIcon,
     IncentivesIcon,
     CommunicationsIcon,
     KnowledgeIcon,
     DataManagementIcon,
     NewsFeedIcon,
     MessagingIcon,
     ReportsIcon,
     VoucherManagementIcon
} from "../../../styles/images/svg/DashboardIcons";
import { IncentiveActiveIcon } from "../../../styles/images/svg/IncentiveActiveIcon";
import { Tooltip } from "@mui/material";

export const SidebarMenu = (props) => {
     const [isToggle, setToggle] = React.useState(null);
     const [isSubToggle, setSubToggle] = React.useState(null);
     const [innerLink, setInnerLink] = React.useState(null);
     const [isCollapse, setCollapse] = React.useState(false);
     const { open } = props;
     const [subOpen, setSubopen] = useState(false);

     const handleClick = (clickedIndex) => {
          if (isToggle === clickedIndex) {
               setToggle(null);
          } else {
               setToggle(clickedIndex);
          }
     };

     const handleInnerSubNav = (clickedIndex) => {
          if (innerLink === clickedIndex) {
               setInnerLink(null);
          } else {
               setInnerLink(clickedIndex);
          }
     };

     const renderTooltip = (children, title) => {
          return open ? (
               children
          ) : (
               <Tooltip title={title} placement="right" arrow>
                    {children}
               </Tooltip>
          );
     };

     const handleSubNav = (clickedIndex) => {
          if (isSubToggle === clickedIndex) {
               setSubToggle(null);
               setSubopen(false);
          } else {
               setSubToggle(clickedIndex);
               setSubopen(true);
          }

     }



     const navs = [
          {
               id: 1,
               name: "Dashboards",
               icon: <DashboardIcon />,
               activeicon: <DashboardIcon />,
               to: "/ui/dashboard",
               items: [
               ],
          },
          // {
          // 	id: 2,
          // 	name: 'Locations',
          // 	icon: <LocationIcon />,
          // 	activeicon: <LocationIcon />,
          // 	to: '/ui/locations',
          // 	items: [
          // 		{
          // 			name: 'Manage Locations',
          // 			to: '/ui/locations',
          // 		},
          // 	],
          // },

          {
               id: 2,
               name: "Featured Content",
               icon: <HomeContentIcon />,
               activeicon: <HomeContentIcon />,
               items: [
                    {
                         name: "Home",
                         to: "/ui/locations",
                         innerItems: []
                    },
                    {
                         name: "Incentives",
                         to: "/ui/locations",
                         innerItems: []
                    },
                    {
                         name: "Shop",
                         to: "/ui/locations",
                         innerItems: []
                    },
               ],
          },
          {
               id: 3,
               name: "Incentive Campaign",
               icon: <IncentivesIcon />,
               activeicon: <IncentiveActiveIcon />,
               to: "/ui/campaign-management",
               items: [
                    // {
                    //      name: "Manage Incentives",
                    //      to: "/ui/campaign-management",
                    // },
               ],
          },
          {
               id: 4,
               name: "Newsfeed",
               icon: <NewsFeedIcon />,
               activeicon: <NewsFeedIcon />,
               to: "/ui/newsfeed",
               items: [
               ],
          },
          {
               id: 5,
               name: "Communications",
               icon: <CommunicationsIcon />,
               activeicon: <CommunicationsIcon />,
               to: "/ui/message-service",
               items: [],
          },
          {
               id: 6,
               name: "Messaging",
               icon: <MessagingIcon />,
               activeicon: <MessagingIcon />,
               to: "/ui/manage-marcoms",
               items: [],
          },
          {
               id: 7,
               name: "Reports",
               icon: <ReportsIcon />,
               activeicon: <ReportsIcon />,
               to: "/ui/locations",
               items: [],
          },
          {
               id: 9,
               name: "User Management",
               icon: <ParticipantsIcon />,
               activeicon: <ParticipantsIcon />,
               items: [
                    {
                         name: "Users",
                         to: "/ui/users",
                         innerItems: []
                    },
                    {
                         name: "Roles",
                         to: "/ui/roles",
                         innerItems: []
                    },
                    {
                         name: "Permissions",
                         to: "/ui/permissions",
                         innerItems: []
                    },
               ],
          },

          {
               id: 10,
               name: "Sales Management",
               icon: <DataManagementIcon />,
               activeicon: <DataManagementIcon />,
               items: [
                    {
                         name: "Table Schema",
                         innerItems: [

                              {
                                   name: "Lookup Tables",
                                   to: "/ui/lookup-data-manage",

                              },
                              {
                                   name: "Fact Tables",
                                   to: "/ui/fact-data-manage",
                              },
                         ]
                    },

                    {
                         name: "Sales Data Upload",
                         to: "/ui/data-upload",
                         innerItems: []
                    },
               ],
          },
          {
               id: 11,
               name: "Voucher Management",
               icon: < VoucherManagementIcon />,
               activeicon: <VoucherManagementIcon/>,
               to: "/ui/voucher-management",
               items: [],
          },
     ];

     return (
          <>
               {navs.map((elm, index) => {
                    return (
                         <div
                              className="sbt-dashboard-sidebar__item"
                              key={elm.id}
                         >
                              <ListItem
                                   disablePadding
                                   sx={{ display: "block" }}
                                   key={index}
                              >
                                   {renderTooltip(
                                        <ListItemButton
                                             sx={{
                                                  minHeight: 48,
                                             }}
                                             onClick={() => handleClick(index)}
                                             component={ReactRouterLink}
                                             to={elm.to}
                                        >
                                             <ListItemIcon
                                                  sx={{
                                                       minWidth: 0,
                                                       mr: open ? 3 : "auto",
                                                       width:'25px'
                                                  }}
                                             >
                                                  {isToggle === index
                                                       ? elm.activeicon
                                                       : elm.icon}
                                             </ListItemIcon>

                                             <ListItemText
                                                  primary={elm.name}
                                                  sx={{
                                                       opacity: open ? 1 : 0,
                                                       color:
                                                            isToggle === index
                                                                 ? "red"
                                                                 : "",
                                                  }}
                                             />
                                             {elm.items.length > 0 &&
                                                  open ? (
                                                  isToggle === index ? (
                                                       <img
                                                            src={
                                                                 ListIconArrowUp
                                                            }
                                                       />
                                                  ) : (
                                                       <img
                                                            src={
                                                                 ListIconArrowDown
                                                            }
                                                       />
                                                  )
                                             ) : (
                                                  ""
                                             )
                                             }

                                             {/* {open ? renderArrowIcon(index, elm.showArrows) : ""} */}
                                        </ListItemButton>,
                                        elm.name,
                                   )}

                                   <>
                                        {elm.items.map((element, elementIndex) => {
                                             return (
                                                  <>
                                                       <Collapse
                                                            in={
                                                                 open &&
                                                                 isToggle ===
                                                                 index
                                                            }
                                                            timeout="auto"
                                                            unmountOnExit
                                                            sx={{ background: "#ebe9e9", borderBottom: '2px solid white' }}
                                                       >
                                                            <List
                                                                 component="div"
                                                                 disablePadding

                                                            >
                                                                 <ListItemButton
                                                                      sx={{
                                                                           pl: 8,
                                                                      }}
                                                                      component={
                                                                           ReactRouterLink
                                                                      }
                                                                      onClick={() => handleSubNav(elementIndex)}
                                                                      to={
                                                                           element.to
                                                                      }
                                                                 >
                                                                      <ListItemText
                                                                           primary={
                                                                                element.name
                                                                           }
                                                                           sx={{
                                                                                color:
                                                                                     isSubToggle ===
                                                                                          elementIndex
                                                                                          ? "red"
                                                                                          : "",
                                                                           }}

                                                                      />


                                                                      {
                                                                           element.innerItems.length > 0 ?
                                                                                subOpen && isSubToggle === elementIndex ? (

                                                                                     <img
                                                                                          src={
                                                                                               ListIconArrowUp
                                                                                          }
                                                                                     />
                                                                                ) : (
                                                                                     <img
                                                                                          src={
                                                                                               ListIconArrowDown
                                                                                          }
                                                                                     />
                                                                                )
                                                                                : ''

                                                                      }

                                                                 </ListItemButton>

                                                            </List>
                                                            <Collapse
                                                                 in={
                                                                      subOpen && isSubToggle ===
                                                                      elementIndex
                                                                 }
                                                                 timeout="auto"
                                                                 unmountOnExit
                                                                 sx={{ background: "#f4f4f4" }}
                                                            >
                                                                 {element.innerItems &&
                                                                      element.innerItems.map((eleData, innerIndex) => {
                                                                           return (<>


                                                                                <List
                                                                                     component="div"
                                                                                     disablePadding

                                                                                >
                                                                                     <ListItemButton
                                                                                          sx={{
                                                                                               pl: 8,
                                                                                          }}
                                                                                          component={
                                                                                               ReactRouterLink
                                                                                          }
                                                                                          to={
                                                                                               eleData.to
                                                                                          }
                                                                                     >
                                                                                          <ListItemText
                                                                                               primary={
                                                                                                    eleData.name
                                                                                               }
                                                                                               onClick={() => handleInnerSubNav(innerIndex)}
                                                                                               sx={{
                                                                                                    color:
                                                                                                         innerLink ===
                                                                                                              innerIndex
                                                                                                              ? "red"
                                                                                                              : "",
                                                                                               }}


                                                                                          />

                                                                                     </ListItemButton>

                                                                                </List>
                                                                           </>)
                                                                      })}

                                                            </Collapse>

                                                       </Collapse>

                                                  </>
                                             );
                                        })}

                                   </>
                              </ListItem>
                         </div>
                    );
               })}
          </>
     );
};
